import { render, staticRenderFns } from "./InternalProcesses.vue?vue&type=template&id=5471d110&"
import script from "./InternalProcesses.vue?vue&type=script&lang=js&"
export * from "./InternalProcesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports